<template>
  <span class="svolt-title">
    <div class="bj">
      <img src="/static/images/svolt/nanwang/title-bj.png"/>
    </div>
    <div class="content">
      <span class="left">
        <slot>{{title}}</slot>
      </span>
    </div>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Array,
        default(){
          return [
          ]
        }
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .svolt-title{
   position: relative;
   top: 0;
   left: 0;
   width: 415px;
   height: 26px;
   line-height: 26px;
   display: inline-block;
   .bj{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 1;
     img{
       width: 416px;
       height: 31px;
     }
   }
   .content{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 10;
     color: #FFFFFF;
     .left{
       font-size: 16px;
       font-weight: 600;
       font-family: PingFangSC-Semibold, PingFang SC;
       display: inline-block;
       margin-top: 2px;
       margin-left:14px;
     }
   }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/title.vue